import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { ShowFileDialog } from 'src/app/views/dialogs-show-file/show-file-dialog.component';
import { ShowMultipleFilesDialog } from 'src/app/views/dialogs-show-file/show-multiple-files-dialog.component'
import { AppService } from '../app.service';
import { Subject } from 'rxjs';
import { $ } from 'protractor';

@Injectable({
    providedIn: 'root',
})
export class PayslipService {
    user;
    
    constructor(
        private dialog: MatDialog,
        private appService: AppService,
    ) {}

    private getPayslipData(payslip) {
        let pdfExt : RegExp = /\.pdf$/;
        let fileUrls = [];
        let fileData = {
            url: payslip["urlfront"] ? payslip["urlfront"] : payslip["url"],
            pdf: pdfExt.test(payslip['nom']) ? true : false,
            name: payslip[0] ? payslip[0]['nom'] : payslip['nom'],
            page : payslip['page'] ? payslip['page'] : 1,
            show : true,
        };

        if (fileUrls.includes(fileData.url)) {
            fileData.show = false;
        } else {
            fileUrls.push(fileData.url); 
        }

        return fileData;
    }

    showPayslip(payslips: Array<any>) {
        let data = [];

        payslips.forEach(payslip => {
            data.push(this.getPayslipData(payslip));
        });
            
        this.dialog.open(ShowFileDialog, {
            width: '100%',
            panelClass:'viewpdf-dialog',
            data: data,
        });
    }

    showMultiplePayslips(payslips: Array<any>) {
        let data = [];
        payslips.forEach(payslip => {
            let payslipData = [];
            payslipData.push(this.getPayslipData(payslip.data));
            payslip.otherPages.forEach(page => {
                payslipData.push(this.getPayslipData(page));
            });
            data.push(payslipData);
        });

        this.dialog.open(ShowMultipleFilesDialog, {
            width: '100%',
            panelClass:'viewpdf-dialog',
            data: data,
        });
    }

    removePayslip(fichier) {
        let result = new Subject<any>();
        let listId = [];
        let secondaryPayslip = false;
        if (Array.isArray(fichier)) {
            fichier.forEach((element, index)=> {
                if (index >= 0)
                    listId.push(element.id);
            })
        } else {
            listId.push(fichier.id);
        }
        if (listId.length > 0) {
            secondaryPayslip = true;
        }
        this.appService.removeBulletin(listId, secondaryPayslip).subscribe((res)=> {
            result.next(res.result == "OK");
        })

        return result.asObservable();
    }
}